import React, {Component} from 'react';
import {Form} from "semantic-ui-react";
import {connect} from "react-redux";
import {getLocalization} from "../utils/localization";


const mapStateToProps = (state, ownProps) => {
    const {user:{lang}} = state;
    return {
        ...ownProps,
        lang,
    }

}

class FormSelectState extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            selectedState: props.initialValue,
        }
    }

    render() {
        const {options, disabled, name, onChange, lang} = this.props;
        const {error, selectedState} = this.state;
        const localization = getLocalization(lang);
        const strings = localization.formSelectState;
        return (
            <Form.Field fluid width={6}>
                <Form.Select required
                             label={strings.state}
                             value={!selectedState ? '' : selectedState}
                             disabled={disabled}
                             options={options}
                             error={!!error}
                             onChange={(e, {value})=>{
                                 this.setState({
                                     selectedState: value,
                                     error: null,
                                 });
                                 onChange(e, {name, value})
                             }}
                />
                {!!error && <small className={'errorText'}>{error}</small>}
            </Form.Field>
        );
    }
}

export default connect(mapStateToProps)(FormSelectState);